// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveInstitutionCourseBlockDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import InstitutionCourseBlockDetailDTO from '../models/InstitutionCourseBlockDetailDTO';
import InstitutionCourseBlockDTO from '../models/InstitutionCourseBlockDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    institutionCourseBlockDetail: InstitutionCourseBlockDetailDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            institutionCourseBlockDetail: null,
        },
        initValues);
    },
    institutionCourseBlockDetail: 'institutionCourseBlockDetail',
}

interface Result extends ResultDTO {
    institutionCourseBlock: InstitutionCourseBlockDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            institutionCourseBlock: null,
        },
        initValues);
    },
    institutionCourseBlock: 'institutionCourseBlock',
}

export { Request, Result };